import { borderRadius, height } from '@mui/system';

const classes = {
  event: {},
  bannerMobile: {
    width: '100%',
    marginTop: '10px',
    objectFit: 'contain',
  },
  banner: {
    width: '100%',
    height: '100%',
    objectFit: 'fill',
    borderRadius: 10,
  },
  link: {
    textDecoration: 'none',
  },
};

export default classes;
